import styled from "styled-components";

export const Container = styled.div`
    margin-left: 15px;
    display: flex;
`